const blacklistedSearchParams = ['email', 'firstName', 'lastName', 'dob'];

const removeBlacklistParams = (location, props = {}) => {
    const url = new URL(location.href);
    blacklistedSearchParams.forEach((p) => url.searchParams.delete(p));
    const search = !url.search && location.search ? '?' : url.search;

    return { ...props, url: url.href, search };
};

export default removeBlacklistParams;
